import api from "@/auth/api";
import { alertSuccess, alertError } from "@/components/Alert";
import React, { useEffect, useState } from "react";
import { fetchPanelUser , setPageSize  , clearCache} from "@/slices/panelUserSlice";
import { useDispatch, useSelector } from "react-redux";



function AddUserBlackList({onClose, user}) {
    const dispatch = useDispatch();
  const [userId, setUserId] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [type, setType] = useState("");
  const [detail, setDetail] = useState("");
  const {panelUserList , search} = useSelector((state) => state.panelUser);
  const [blackListType, setBlackListType] = useState([]);

  const getBlackListType = async () => {
    try {
      const response = await api.get("/PanelHome/panel/blackListType");
      setBlackListType(response.data.result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
  if (user) {
    setUserId(user.id);
    setUserEmail(user.fullName || user.email);
  }
}, [user]);

  useEffect(() => {
    getBlackListType();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/PanelHome/panel/UserblackList", {
        userId:parseInt(userId),
        Type:parseInt(type),
        detail,
      });
      if (!response.error) {
        alertSuccess("Black list type added successfully");
         await dispatch(clearCache()); // resets cache internally
        await dispatch(fetchPanelUser({ page: 1, search : ""}));
        onClose()
        // onSuccess();
      }
    } catch (error) {
      console.error("Error:", error);
      alertError(error.response?.data?.errors || "An error occurred");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center flex-col gap-4 p-4"
    >
     <input
        type="text"
        value={userEmail}
        readOnly
        className="border p-2 rounded w-full max-w-sm bg-gray-100 cursor-not-allowed"
        />

      <select
        value={type}
        onChange={(e) => setType(e.target.value)}
        required
        className="border p-2 rounded w-full max-w-sm"
      >
        <option value="" disabled>
          Select Type
        </option>
        {blackListType.map((item) => (
          <option key={item.id} value={item.id}>
            {item.title}
          </option>
        ))}
      </select>

      <input
        type="text"
        placeholder="Enter detail"
        required
        value={detail}
        onChange={(e) => setDetail(e.target.value)}
        className="border p-2 rounded w-full max-w-sm"
      />

      <button
        type="submit"
        className="activeBtn rounded-sm w-fit text-white p-2"
      >
        Submit
      </button>
    </form>
  );
}

export default AddUserBlackList;
